import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteConfirmationModal from "../../../components/commonComponent/DeleteConfirmationModal";
import Pagination from "../../../components/commonComponent/Pagination";
import Search from "../../../components/commonComponent/Search";
import Table from "../../../components/commonComponent/Table";
import ViewModal from "../../../components/commonComponent/ViewModal";
import useModal from "../../../hooks/useModal";
import "../../../styles/SolarStation.css";
import { deleteData } from "../../../utils/utils";
import useLoader from "../../../hooks/useLoader";

const API_URL = process.env.REACT_APP_API_URL;

const columns = [
  { header: "Name", accessor: "fullName" },
  { header: "Email", accessor: "email" },
  { header: "Address", accessor: "address" },
  { header: "Phone Number", accessor: "phoneNumber" },
];

const ITEMS_PER_PAGE = 10;

const User = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { loading, showLoader, hideLoader } = useLoader();

  const {
    showDeleteModal,
    showViewModal,
    selectedItem,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    handleOpenViewModal,
    handleCloseViewModal,
  } = useModal();

  const fetchUsers = async () => {
    try {
      showLoader();
      const response = await fetch(
        `${API_URL}/users/getAllUser?page=${currentPage}&limit=${ITEMS_PER_PAGE}&search=${searchTerm}`
      );
      const result = await response.json();

      if (response.ok) {
        setData(result.data);
        setTotalPages(result.totalPages);
      } else {
        setError(result.error);
      }
    } catch (error) {
      setError("Failed to fetch data");
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    if (searchTerm.length >= 2 || searchTerm === "") {
      fetchUsers();
    }
  }, [currentPage, searchTerm]);

  const handleSearch = (term) => {
    if (term.length >= 2) {
      setSearchTerm(term);
      setCurrentPage(1);
    } else if (term.length === 0) {
      setSearchTerm("");
      setCurrentPage(1);
    }
  };

  const handleDeleteConfirm = () => {
    deleteData(`${API_URL}/users/deleteUserById`, selectedItem._id, setError)
      .then(() => {
        setData((prevData) =>
          prevData.filter((item) => item._id !== selectedItem._id)
        );
        toast.success("Deleted successfully");
        fetchUsers();
      })
      .catch((error) => {
        setError(error);
        toast.error("Error deleting data");
      });
    handleCloseDeleteModal();
  };

  const fieldsToShow = {
    Name: "fullName",
    Email: "email",
    Phone: "phoneNumber",
    Address: "address",
  };

  return (
    <div>
          <h2 className="capitalize font-bold text-[24px] mb-4">Users List</h2>

      <div className="flex justify-between items-center shadow-md px-8 py-[10px] rounded-md bg-[#fff] text-base mb-4">
        <div className="flex items-center">

          <div className="search-filter-container">
            <Search
              searchFields={["Name", "Email", "Phone Number"]}
              onSearch={handleSearch}
            />
          </div>
        </div>

        <Link
          to="/userManagement/add"
          className="inline-flex items-center justify-center rounded-md border border-white px-4 py-1.5 text-center font-medium text-white bg-[#1C2434] hover:bg-opacity-90"
        >
          Add User
        </Link>
      </div>

      <div>
        <Table
          columns={columns}
          data={data}
          showIndex={true}
          onDelete={handleOpenDeleteModal}
          onUpdate={(item) => navigate(`/userManagement/edit/${item._id}`)}
          onView={handleOpenViewModal}
          actions={{
            showView: true,
            showEdit: true,
            showDelete: true,
          }}
          loading={loading}
        />
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      </div>

      <DeleteConfirmationModal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onConfirm={handleDeleteConfirm}
      />

      <ViewModal
        show={showViewModal}
        onHide={handleCloseViewModal}
        data={selectedItem}
        fields={fieldsToShow}
      />
    </div>
  );
};

export default User;
